import { useRecordContext } from 'react-admin'

const CustomSvgField = () => {
  const record = useRecordContext()
  if (record && record.rawFile && record.rawFile instanceof File) {
    return (
      <img
        alt=""
        src={URL.createObjectURL(record.rawFile)}
        style={{ height: 80, width: 80 }}></img>
    )
  }
  return <embed src={record} style={{ height: 80, width: 80 }}></embed>
}

export default CustomSvgField
